import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { getUserProfile, paymentConfirm, preparePayment } from 'api'
import OrderForm from './OrderForm'
import { showErrorMessage } from 'utils/showMessage'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from 'hooks'
import { isAdminPage } from 'utils/isAdminPage'
import { subscriptionsActions } from 'store/reducers/subscriptions/subscriptions'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import CheckoutForm from '../../components/organisms/auth/CheckoutForm'

const PaymentPage = () => {

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  console.log("stripePromise")
  console.log(stripePromise)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.subscriptions.registrationToken || localStorage.getItem('token'))
  const selectedPlan = useSelector((state) => state.subscriptions.plan)
  const discountCode = useSelector((state) => state.subscriptions.discountCode)
  const isEmpty = (obj) => Object.keys(obj).length === 0;
  const { onLogin, handleSetProfile } = useAuth()
  const [subscription, setSubscription] = useState(null)
  const login_res = location?.state?.login_res
  const [registrationToken, setRegistrationToken] = useState('')
  const [discount, setDiscount] = useState({})
  const [plan, setPlan] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [clientSecret, setClientSecret] = useState(null);
  const [setupIntentId, setSetupIntentId] = useState(null);

  const paymentValidationSchema = Yup.object({
    seat_number: Yup.string().required(t("Required")),
    discount_code: Yup.string(),
    subscription_type: Yup.string().required(t("Required")),
    redirect_url: Yup.string().required(t("Required")),
  })

  const paymentValues = {
    seat_number: plan?.sits?.toString(),
    discount_code: discount || '',
    subscription_type: plan?.type == 'year' ? 'YEARLY' : 'MONTHLY',
  }

  // Inizializzazione di Formik
  const formik = useFormik({
    initialValues: () => (paymentValues),
    validationSchema: () => (paymentValidationSchema),
    onSubmit: (values) => {
    },
  });

  const prepare = useMutation({
    mutationKey: 'prepare',
    mutationFn: () => preparePayment(registrationToken),
    onSuccess: async (res) => {


      setClientSecret(res?.resData?.data?.client_secret);
      setSetupIntentId(res?.resData?.data?.setup_intent_id);
    },
    onError: (err) => {
      setIsLoading(false)
     // showErrorMessage(t('error messages.Payment failed'))
    }
  })

  const confirm = useMutation({
    mutationKey: 'payment-confirm',
    mutationFn: (values) => paymentConfirm(values, (registrationToken || token)),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: async (res) => {

      dispatch(subscriptionsActions.setRegistrationToken(res?.resData?.data?.access_token))
      localStorage.setItem('token', res?.resData?.data?.access_token)
      getUserProfile(res?.resData?.data?.access_token).then(() => {
        setIsLoading(false)
        handleSetProfile(res?.resData?.data?.user, res?.resData?.data?.user?.role)
        onLogin(res?.resData?.data?.access_token, isAdminPage())
        navigate('/order-confirmed', { state: { login_res: login_res } })
      }, err => {
        showErrorMessage(t('error messages.Internal server error'))
        setIsLoading(false)
      })

    },
    onError: (err) => {

      setIsLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  })


  useEffect(() => {
    if(registrationToken && registrationToken.length > 0){
      prepare.mutate()
    }

  }, [registrationToken]);

  useEffect(() => {
    const type = plan?.type == 'year' ? 'YEARLY' : 'MONTHLY'
    formik.setFieldValue('subscription_type', type)
    formik.setFieldValue('seat_number', plan?.sits?.toString())
  }, [plan])

  useEffect(() => {
    if (login_res) {
      if (login_res?.company?.subscription?.id !== 0) {
        setSubscription(login_res?.company?.subscription)
      } else {
        const temporary_data = JSON.parse(login_res?.temporary_data)

        localStorage.setItem('plan', JSON.stringify(temporary_data?.selectedPlan))
        setPlan(temporary_data?.selectedPlan)
        setDiscount({
          code: temporary_data?.discountCode?.code,
          discount_value: temporary_data?.discountCode?.discount_value
        })
      }

    } else {
      if (!isEmpty(selectedPlan)) {
        setPlan(selectedPlan)
      } else {
        setPlan(JSON.parse(localStorage.getItem('plan')))
      }
    }
  }, [selectedPlan])

  useEffect(() => {

    if (discountCode) {
      setDiscount(discountCode)
    } else {
      // console.log('discountCode', JSON.parse(localStorage.getItem('discount')));
      setDiscount(JSON.parse(localStorage.getItem('discount')))
    }
  }, [discountCode])

  useEffect(() => {
    if (discount) {
      formik.setFieldValue('discount_code', discount.code)
    }
  }, [discount])

  useEffect(() => {
    if (token && token?.length > 0) {
      localStorage.setItem('registrationToken', token)
      setRegistrationToken(token)
    } else {
      setRegistrationToken(localStorage.getItem('registrationToken'))
    }
  }, [token])



  return (
    <div className="grid grid-cols-3 h-screen w-screen bg-[#F7F7F8] p-2">
      {/* Form */}
    {/*  <div className="col-span-2 justify-left w-full h-full bg-white rounded-2xl p-[40px]">

        {!login_res && (<p className="text-sm text-[#828282] font-normal">Step 4 {t("OF").toLowerCase()} 5</p>)}

        <p className="text-3xl text-black font-semibold">{t("Pay.Title")}</p>
        <p className="text-base text-[#828282] font-normal">{t("Pay.Subtitle")}</p>

        <form onSubmit={formik.handleSubmit} className="mt-[40px]">

          <div>

            <div className="flex gap-2 items-center">
              <p className="text-sm font-normal text-[#595961]">{t("Pay.AcceptedCards")}</p>

              <img src={Amex} style={{ width: '32px' }} alt="amex" />
              <img src={Visa} style={{ width: '32px' }} alt="visa" />
              <img src={Discover} style={{ width: '32px' }} alt="discover" />
              <img src={Mastercard} style={{ width: '32px' }} alt="" />
              <img src={Jcb} style={{ width: '32px' }} alt="" />
              <img src={Diners} style={{ width: '32px' }} alt="" />
              <img src={UnionPay} style={{ width: '32px' }} alt="" />

            </div>


            <p className="text-sm font-normal text-[#595961] mt-4">{t("Pay.Number")}</p>
            <MaskedInput
              mask="0000 0000 0000 0000"
              maskOptions={{ lazy: true }}
              type="text"
              placeholder="Card Number"
              name="card_number"
              value={formik.values.card_number}
              onChange={(e) => {
                const value = e.target.value.replace(/\s+/g, '');
                formik.setFieldValue('card_number', value);
              }}
              onBlur={formik.handleBlur}
              style={{
                width: "100%",
                border: "none",
                borderBottom: "2px solid #E3E3E8",
                borderRadius: "0px",
              }}
            />
            {formik.touched.card_number && formik.errors.card_number && (
              <p className="text-red-500 text-xs mt-1">{formik.errors.card_number}</p>
            )}


            <div className="flex gap-4">
              <div className="w-full">
                <p className="text-sm font-normal text-[#595961] mt-4">{t("Pay.Expiration")}</p>
                <MaskedInput
                  mask="00/0000"
                  maskOptions={{ lazy: true }}
                  placeholder="MM/YYYY"
                  type="text"
                  name="card_exp_year"
                  onChange={(e) => {
                    formik.setTouched({
                      card_exp_month: true,
                      card_exp_year: true,
                    })
                    const [month, year] = e.target.value.split("/").map(String);
                    if (month && year) {
                      formik.setFieldValue('card_exp_month', month?.toString())
                      formik.setFieldValue('card_exp_year', year?.toString())
                    } else {
                      formik.setFieldValue('card_exp_month', '')
                      formik.setFieldValue('card_exp_year', '')
                    }
                  }}
                  style={{
                    width: "100%",
                    border: "none",
                    borderBottom: "2px solid #E3E3E8",
                    borderRadius: "0px",
                  }}
                />
                {formik.touched.card_exp_month && formik.errors.card_exp_month && (
                  <p className="text-red-500 text-xs mt-1">{formik.errors.card_exp_month}</p>
                )}
                {formik.touched.card_exp_year && formik.errors.card_exp_year && (
                  <p className="text-red-500 text-xs mt-1">{formik.errors.card_exp_year}</p>
                )}
                {formik.errors.expDateValid && (
                  <p className="text-red-500 text-xs mt-1">{formik.errors.expDateValid}</p>
                )}


              </div>

              <div >
                <p className="text-sm font-normal text-[#595961] mt-4">CVV</p>
                
                <MaskedInput
                  mask="0000"
                  maskOptions={{ lazy: true }}
                  placeholder="CVC"
                  type="text"
                  name="card_cvv"
                  value={formik.values.card_cvv}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\s+/g, '');
                    formik.setFieldValue('card_cvv', value);
                  }}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    border: "none",
                    borderBottom: "2px solid #E3E3E8",
                    borderRadius: "0px",
                  }}
                />
                {formik.touched.card_cvv && formik.errors.card_cvv && (
                  <p className="text-red-500 text-xs mt-1">{formik.errors.card_cvv}</p>
                )}


              </div>

               <div>
                <p className="text-sm font-normal text-[#595961]">{t("Pay.StreetNumber")}</p>
                <Input
                  type="text"
                  name="number"
                  value={formik.values.number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    border: "none",
                    borderBottom: "2px solid #E3E3E8",
                    borderRadius: "0px",
                  }}
                />
                {formik.touched.number && formik.errors.number && (
                  <p className="text-red-500 text-xs mt-1">{formik.errors.number}</p>
                )}
              </div>

            </div>



          </div>



           Pulsanti
          <div className="mt-[58px] flex justify-end">
             <Button
              onClick={() => {
                navigate(-1)
              }}
              type="button"
              variant="outlined"
              sx={{
                width: 124,
                borderColor: "#919191",
                fontSize: "16px",
                textTransform: "none",
                color: "#919191",
                paddingLeft: "22px",
                paddingRight: "22px",
                fontWeight: 600,
                marginRight: 2,
              }}
            >
              {t("Signup.Back")}
            </Button>

            <Button
              type="submit"
              variant="contained"
              disabled={!formik.isValid || !formik.dirty || loading}
              sx={{
                width: loading ? 148 : 124,
                paddingLeft: "22px",
                paddingRight: "22px",
                fontWeight: 600,
                backgroundColor: formik.isValid ? "#0049EE" : "#A0A0A0",
                fontSize: "16px",
                textTransform: "none",
              }}
            >
              {t("Otp.Buy")}
              {loading && (<CircularProgress size="20px" style={{ marginLeft: 8, color: 'white' }} />)}
            </Button>
          </div>
        </form>
      </div>*/}

      <div className="col-span-2 justify-left w-full h-full bg-white rounded-2xl p-[40px]">
        <Elements stripe={stripePromise}>
          <CheckoutForm
            isLoading={isLoading}
            isDirect={false}
            clientSecret={clientSecret}
            onSubmit={()=>{

              const discount_code = discount

            const body = {
              setup_intent_id : setupIntentId, //  lo stesso della prepare
              seat_number     : formik.values.seat_number,
              subscription_type: formik.values.subscription_type,
              discount_code: discount_code?.code
            }

            confirm.mutate(body)

          }} />
        </Elements>
      </div>


      {/* Sidebar con dettagli */}
      <OrderForm showDiscount={true} login_res={login_res} />
    </div>
  );
};

export default PaymentPage;
